import { FC } from 'react'
import cn from 'classnames'
import type { Field } from '@/api/types/crm/crm.types'
import classes from './index.module.css'
import compactFieldClasses from '@pages/Admin/CRM/styles/compactLeadFields.module.css'
import LeadField from '../../components/LeadField/LeadField'
import useFullLeadModalAccess from '../../hooks/useFullLeadModalAccess'
import {
  buildLeadPhoneFieldSettings,
  getLeadFieldValue,
} from '@pages/Admin/CRM/utils/leadFields'
import type { LeadProfileLead } from '../../LeadProfileModal.types'
import LeadProfileModalBlock from '../../components/LeadProfileModalBlock/LeadProfileModalBlock'
import { filterOptionalTextareaFields } from './aboutTabFields'

interface WideAboutContentProps {
  lead: LeadProfileLead
  fields: Field[]
  fieldsData: Record<string, string>
  updateFieldData: (uniqueNameField: string, value: string) => void
  onOpenVkChatWithLead?: (
    leadId: number,
    options?: { conversationId?: number },
  ) => void
  onOpenMaxChatWithLead?: (
    leadId: number,
    options?: { conversationId?: number },
  ) => void
  onOpenTelegramChatWithLead?: (
    leadId: number,
    options?: { conversationId?: number },
  ) => void
  onOpenWazzupChatWithLead?: (
    leadId: number,
    options?: { conversationId?: number },
  ) => void
}

const WideAboutContent: FC<WideAboutContentProps> = ({
  lead,
  fields,
  fieldsData,
  updateFieldData,
  onOpenVkChatWithLead,
  onOpenMaxChatWithLead,
  onOpenTelegramChatWithLead,
  onOpenWazzupChatWithLead,
}) => {
  const access = useFullLeadModalAccess()
  const optionalTextAreaFields = filterOptionalTextareaFields(fields)

  return (
    <LeadProfileModalBlock
      aria-label="Текстовые поля"
      title="Текстовые поля"
      className={classes.aboutWideCard}
    >
      {optionalTextAreaFields.length === 0 ? (
        <p className={classes.aboutEmpty}>
          Нет настраиваемых текстовых полей. Их можно добавить в настройках
          воронки.
        </p>
      ) : (
        <div className={cn(classes.listTextAreaFields, compactFieldClasses.root)}>
          {optionalTextAreaFields.map((field) => {
            const defaultValue = getLeadFieldValue(lead, field.unique_name) ?? ''
            const currentValue = fieldsData[field.unique_name] ?? ''

            return (
              <div key={field.id} className={classes.textareaStackItem}>
                <LeadField
                  field={field}
                  size="small"
                  value={fieldsData[field.unique_name] ?? ''}
                  onChange={(val) => updateFieldData(field.unique_name, val)}
                  fieldSettings={
                    field.type === 'phone_number' &&
                    (onOpenVkChatWithLead ||
                      onOpenMaxChatWithLead ||
                      onOpenTelegramChatWithLead ||
                      onOpenWazzupChatWithLead)
                      ? buildLeadPhoneFieldSettings({
                          canInteractWithIntegrations:
                            access.canInteractWithIntegrations,
                          lead,
                          field,
                          defaultValue,
                          currentValue,
                          onOpenVkChat: (options) => {
                            onOpenVkChatWithLead?.(lead.id, options)
                          },
                          onOpenMaxChat: onOpenMaxChatWithLead
                            ? (options) => onOpenMaxChatWithLead(lead.id, options)
                            : undefined,
                          onOpenTelegramChat: onOpenTelegramChatWithLead
                            ? (options) =>
                                onOpenTelegramChatWithLead(lead.id, options)
                            : undefined,
                          onOpenWazzupChat: onOpenWazzupChatWithLead
                            ? (options) =>
                                onOpenWazzupChatWithLead(lead.id, options)
                            : undefined,
                        })
                      : undefined
                  }
                  disabled={!access.canEditFields}
                />
              </div>
            )
          })}
        </div>
      )}
    </LeadProfileModalBlock>
  )
}

export default WideAboutContent
